module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scheduler"
  }, [(_vm.activeUser !== null) ? _c('SchedulerSubsSubstituteHours', {
    attrs: {
      "item": _vm.activeUser,
      "itemBCR": _vm.activeUserBCR
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "scheduler__header"
  }, [_c('li', [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScrollTop),
      expression: "handleScrollTop"
    }],
    ref: "topDiv",
    staticClass: "do-scroller do-scroller--hide"
  }, [_c('ul', {
    staticClass: "scheduler__header__times"
  }, _vm._l((_vm.hoursInLocale), function(number) {
    return _c('li', [_vm._v(_vm._s(_vm.$filters.LT(number)))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "scheduler__container",
    class: {
      'scheduler__container--loading': _vm.dataIsLoading
    }
  }, [(_vm.dataIsLoading) ? _c('div', {
    staticClass: "scheduler__container__loader"
  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "do-scroller__container"
  }, [_c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScrollLeft),
      expression: "handleScrollLeft"
    }],
    ref: "leftDiv",
    staticClass: "do-scroller do-scroller-max-height do-scroller--hide do-scroller__users",
    style: ({
      maxHeight: _vm.schedulerMaxHeight + 'px',
      paddingBottom: _vm.isVerticalScrollbar ? '15px' : '0px'
    })
  }, [_c('ul', {
    staticClass: "scheduler__users"
  }, _vm._l((_vm.items), function(item, idx) {
    return _c('li', {
      key: item.id,
      class: {
        'item-is-headline': item.headline
      },
      style: ({
        'height': _vm.getUserRowHeight(item)
      })
    }, [(item.headline) ? _c('div', {
      staticClass: "scheduler__users__headline"
    }, [_c('div', {
      staticClass: "scheduler__users__user__name"
    }, [_vm._v(_vm._s(_vm.subsTitle))]), _vm._v(" "), _c('div', {
      staticClass: "scheduler__users__user__subpools scheduler__users__user__subpools__title"
    }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler.pool')) + "\n              ")])]) : _c('div', {
      staticClass: "scheduler__users__user",
      class: [{
          'scheduler__users__user--absence-autogenerated': _vm.isAbsenceAutoGenerated(item)
        },
        {
          'scheduler__users__user--not-absent': item.dayAbsence.length < 1
        }
      ]
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          animateFill: false,
          placement: 'right',
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return item.dayAbsence.length < 1; }
        }),
        expression: "{\n              arrow: false,\n              animateFill: false,\n              placement: 'right',\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => item.dayAbsence.length < 1\n            }"
      }],
      staticClass: "scheduler__users__user__name",
      attrs: {
        "title": _vm.i18n.create_activity
      },
      on: {
        "click": function($event) {
          return _vm.setCreateEventOnUserOnNotAbsentUser(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), (_vm.isAbsenceAutoGenerated(item)) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: "right",
          animation: "fade"
        }),
        expression: "{ arrow: true, placement : \"right\", animation : \"fade\" }"
      }],
      staticClass: "absence-generated-sign",
      attrs: {
        "title": _vm.i18n.auto_created
      }
    }, [_c('svg', {
      staticClass: "tw-icon tw-icon-important",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      staticClass: "primary",
      attrs: {
        "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "secondary",
      attrs: {
        "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
      }
    })])]) : _vm._e(), _vm._v(" "), (item.dayAbsence.length > 0) ? _c('DDropdown', [_c('ul', {
      staticStyle: {
        "width": "180px"
      },
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('li', [_c('a', {
      staticClass: "marg-5-left text-link",
      attrs: {
        "href": '/calendars/' + item.user_calendar_id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.i18n.go_to_calendar))])]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.setActiveAbsentUser(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n.add_sub_to_multiple_lessons))]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.setCreateEventOnUser(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n.create_activity))])])]) : _vm._e()], 1), _vm._v(" "), (item.dayAbsence.length === 0) ? _c('div', {
      staticClass: "scheduler__users__user__subpools cursor-help",
      on: {
        "mouseenter": function($event) {
          return _vm.setActiveUser(item, $event)
        },
        "mouseleave": function($event) {
          _vm.activeUser = null
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("round")(item.subPoolsDiff)) + "\n              ")]) : _c('div', {
      ref: 'absence_status_dropdown__parent___' + item.id,
      refInFor: true,
      staticClass: "scheduler__users__user__handled",
      class: {
        'scheduler__users__user__handled--loading': _vm.getIsUserHandlerLoading(item.id)
      },
      on: {
        "click": function($event) {
          return _vm.setTheAbsentUserHandledDropdown(item)
        }
      }
    }, [_c('div', {
      staticClass: "scheduler__users__user__handled__handler",
      class: _vm.schedulerUserHandledCls(item)
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "scheduler__cal"
  }, [_c('div', {
    staticClass: "do-scroller__container"
  }, [_c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScrollRight),
      expression: "handleScrollRight"
    }],
    ref: "rightDiv",
    staticClass: "do-scroller do-scroller-max-height do-scroller--hide",
    style: ({
      maxHeight: _vm.schedulerMaxHeight + 'px'
    })
  }, [_c('ul', {
    staticClass: "scheduler__cal__ress"
  }, [_c('ul', {
    staticClass: "scheduler__cal__ress__items"
  }, _vm._l((_vm.items), function(user) {
    return _c('SchedulerItem', {
      key: user.id,
      attrs: {
        "user": user,
        "locale": _vm.locale,
        "allEvents": _vm.allEvents,
        "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
        "allCalendarsInHash": _vm.allCalendarsInHash,
        "longAbsentListInHash": _vm.longAbsentListInHash,
        "activeEvents": _vm.activeEvents,
        "isActiveEventsLoading": _vm.isActiveEventsLoading,
        "theActiveEventsLoadingOnCalendarId": _vm.theActiveEventsLoadingOnCalendarId,
        "isHideEventsNotOverlappingAbsence": _vm.isHideEventsNotOverlappingAbsence,
        "selectedEventTitleFilters": _vm.selectedEventTitleFilters,
        "selectedQuickFilters": _vm.selectedQuickFilters,
        "selectedClassFilters": _vm.selectedClassFilters,
        "selectedGroupFilters": _vm.selectedGroupFilters
      },
      on: {
        "onChooseSubType": _vm.onChooseSubType,
        "rows": function($event) {
          return _vm.setRows($event, user.id)
        }
      }
    })
  }), 1), _vm._v(" "), _c('ul', {
    staticClass: "scheduler__cal__timeslots"
  }, _vm._l((_vm.hoursInLocale.length * 2), function(n) {
    return _c('li')
  }), 0), _vm._v(" "), (_vm.activeEvents.length < 1) ? _c('SchedulerRulers') : _vm._e(), _vm._v(" "), _vm._l((_vm.activeEvents), function(event) {
    return _c('SchedulerRulers', {
      attrs: {
        "lesson": event
      }
    })
  })], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [((_vm.activeEvent && _vm.activeEvent.obj) || _vm.activeEvents.length > 0) ? _c('div', {
    staticClass: "sub-popover"
  }, [_c('div', {
    staticClass: "icon__bg-circle close-cross",
    on: {
      "click": _vm.closePopover
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('SchedulerPopover', {
    attrs: {
      "activeEventId": _vm.activeEvent,
      "user": _vm.schedulerUser,
      "locale": _vm.locale,
      "activeEvents": _vm.activeEvents,
      "possibleSubs": _vm.items
    },
    on: {
      "chooseSubType": _vm.onChooseSubType,
      "removeSubs": _vm.removeSubs,
      "clickaway": _vm.closePopover,
      "close": _vm.closePopover,
      "showLog": _vm.showLog,
      "deleteEvent": _vm.setDeleteEvent,
      "splitLesson": function($event) {
        return _vm.$emit('splitLesson', $event)
      },
      "editTimes": function($event) {
        return _vm.$emit('editTimes', $event)
      },
      "setTheOutOfSchoolLesson": function($event) {
        return _vm.$emit('setTheOutOfSchoolLesson', $event)
      },
      "setIsCancelLesson": function($event) {
        return _vm.$emit('setIsCancelLesson', $event)
      }
    }
  })], 1) : _vm._e()])], 1)])]), _vm._v(" "), (_vm.theAbsentUserHandledDropdown !== null) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeSubStatusDropdown),
      expression: "closeSubStatusDropdown"
    }],
    ref: "absence_status_dropdown",
    staticClass: "scheduler__users__user__handled__dropdown"
  }, [_c('div', {
    staticClass: "popper-arrow"
  }), _vm._v(" "), _c('ul', {
    staticClass: "scheduler__users__user__handled__absense__reasons"
  }, _vm._l((_vm.theAbsentUserHandledDropdown.dayAbsence), function(absence) {
    return _c('li', {
      staticClass: "scheduler__users__user__handled__absense__reasons__reason"
    }, [_c('h4', [_vm._v(_vm._s(_vm.getAbsenceTitle(absence)))]), _vm._v(" "), _c('ul', [_c('li', {
      on: {
        "click": function($event) {
          return _vm.setAbsenceStatus(_vm.theAbsentUserHandledDropdown, 0)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n          ")]), _vm._v(" "), _c('li', {
      staticClass: "scheduler__users__user__handled__absense__reasons__reason--handled",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setAbsenceStatus(_vm.theAbsentUserHandledDropdown, 1)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n          ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theTeacherOrSubObj) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_c('div', {
    staticClass: "do-modal__choose-as-sub-or-teacher",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2'), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['should']) + " " + _vm._s(_vm.theSubName) + " " + _vm._s(_vm.i18n['be_appointed']) + "?")]), _vm._v(" "), (_vm.isLoadingEvent) ? _c('div', {
    staticClass: "d-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })]) : [_c('button', {
    staticClass: "do-bttn do-bttn__option",
    class: {
      'do-bttn--loading': _vm.isLoadingEvent
    },
    on: {
      "click": _vm.setAsSub
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n['as_a_substitute']) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn__option",
    class: {
      'do-bttn--loading': _vm.isLoadingEvent
    },
    on: {
      "click": _vm.setAsTeacher
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n['as_a_teacher']) + "\n          ")])]], 2)])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent && !_vm.theDeleteEvent.away) ? _c('ModalConfirmation', {
    attrs: {
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        _vm.theDeleteEvent = null
      },
      "confirm": _vm.deleteTheDeleteEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent && _vm.theDeleteEvent.away) ? _c('DModalDeleteAwayEvent', {
    attrs: {
      "event": _vm.theDeleteEvent,
      "eventIdProp": 'id',
      "appendToBody": true
    },
    on: {
      "deleted": _vm.onAwayEventDeleted,
      "close": function($event) {
        _vm.theDeleteEvent = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b1035a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/Scheduler/Scheduler.vue
// module id = 1986
// module chunks = 1